import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, setUserId, setUserProperties } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Firebase web config — these are PUBLIC identifiers, not secrets.
// See: https://firebase.google.com/docs/web/setup#config-object
// Security comes from Firebase Security Rules, not from hiding these values.
const firebaseConfig = {
  apiKey: "AIzaSyBm8AXgSganjdHbjTVwJd0U_ILBrevU3u0",
  authDomain: "callchat-1b563.firebaseapp.com",
  projectId: "callchat-1b563",
  storageBucket: "callchat-1b563.firebasestorage.app",
  messagingSenderId: "771110457214",
  appId: "1:771110457214:web:d214fffb5cf60fcd6d6d2f",
  measurementId: "G-6TBE46J8RK"
};

const VAPID_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || "BLduREtEUwWxShBg0_L37JAHpS87FQ2-a751jOJxcIC5qgFFkLZHhtffoP0jytEPrYJHWZL41DXVF5ZvJxhYVZs";

let analytics = null;
let messaging = null;
let app = null;

try {
  app = initializeApp(firebaseConfig);
  analytics = getAnalytics(app);
} catch (e) {
  console.warn("Firebase analytics init failed:", e);
}

try {
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    messaging = getMessaging(app);
  }
} catch (e) {
  console.warn("Firebase messaging init failed:", e);
}

// ─── FCM Token Management ───
export const getFCMToken = async () => {
  if (!messaging) return null;
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;

    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });
    return token;
  } catch (e) {
    console.warn("FCM token error:", e);
    return null;
  }
};

export const onForegroundMessage = (callback) => {
  if (!messaging) return () => {};
  return onMessage(messaging, (payload) => {
    callback(payload);
  });
};

// ─── Analytics ───
export const trackEvent = (eventName, params = {}) => {
  if (!analytics) return;
  try {
    logEvent(analytics, eventName, params);
  } catch (e) {}
};

export const identifyUser = (userId, properties = {}) => {
  if (!analytics) return;
  try {
    setUserId(analytics, userId);
    if (Object.keys(properties).length > 0) {
      setUserProperties(analytics, properties);
    }
  } catch (e) {}
};

// Pre-defined event helpers
export const track = {
  login: (method = 'email') => trackEvent('login', { method }),
  signup: (method = 'email') => trackEvent('sign_up', { method }),
  logout: () => trackEvent('logout'),
  forgotPassword: () => trackEvent('forgot_password'),
  resetPassword: () => trackEvent('reset_password'),
  pageView: (pageName) => trackEvent('page_view', { page: pageName }),
  newChat: (type = 'direct') => trackEvent('new_chat', { type }),
  sendMessage: (type = 'text') => trackEvent('send_message', { message_type: type }),
  startCall: (type = 'video') => trackEvent('start_call', { call_type: type }),
  endCall: (duration) => trackEvent('end_call', { duration_seconds: duration }),
  generateVideo: (prompt) => trackEvent('generate_ai_video', { prompt_length: prompt?.length || 0 }),
  videoCompleted: () => trackEvent('ai_video_completed'),
  postStatus: (type = 'image') => trackEvent('post_status', { status_type: type }),
  viewPacks: () => trackEvent('view_credit_packs'),
  initPayment: (pack, amount) => trackEvent('begin_checkout', { item_name: pack, value: amount, currency: 'INR' }),
  paymentSuccess: (pack, amount) => trackEvent('purchase', { item_name: pack, value: amount, currency: 'INR' }),
  paymentFailed: (reason) => trackEvent('payment_failed', { reason }),
  installClick: (source) => trackEvent('app_install_click', { source }),
  addContact: () => trackEvent('add_contact'),
  shareApp: (method) => trackEvent('share', { method }),
  searchMessages: () => trackEvent('search_messages'),
  viewGallery: () => trackEvent('view_gallery'),
  viewLeaderboard: () => trackEvent('view_leaderboard'),
};

export default analytics;
